import AdvertisingMasterAddForm from './AdvertisingMasterAddForm';

export default AdvertisingMasterAddForm;
